<header fxLayout="column" fxLayoutAlign="center center" mat-dialog-title>
  <h1 class="mat-card-title">{{ data.dataAccessPolicy.name }}</h1>
  <span class="mat-card-subtitle">Data Usage Agreement</span>
</header>
<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="data.dataAccessPolicy | rdsIsDataUsageAgreement as dua">
    <div *ngIf="dua.dataUsageAgreementContents as contents" class="dua-contents-container">
      <div [innerHTML]="contents"></div>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end center">
  <span fxFlex></span>
  <div [ngSwitch]="data.mode">
    <ng-container *ngSwitchCase="'VIEW'">
      <button mat-raised-button color="primary" matDialogClose i18n>CLOSE</button>
    </ng-container>
    <ng-container *ngSwitchCase="'INIT'">
      <button mat-flat-button (click)="handleDecision(false)">DISAGREE</button>
      <button mat-raised-button color="primary" (click)="handleDecision(true)">AGREE</button>
    </ng-container>
  </div>
</mat-dialog-actions>
